module.exports = __webpack_public_path__ + "1a4b24217473bb2864e65475ed46fd23.png";